import { Types, Keys } from "./actions/types";
import { IState, DefaultState } from "./state";
import { tag } from "../../../model/tag";

export const reducer = (state: IState = DefaultState(), action: Types): IState => {
    switch (action.type) {
        case Keys.LOADTAGS_FULFILLED: {
            let q: Array<tag> = action.payload;
            return {
                ...state,
                tags: q
            }
        }
        case Keys.LOADTAGS_REJECTED: {
            return {
                ...state,
                tags: []
            }
        } case Keys.EDITTAG: {
            return {
                ...state,
                tag: action.payload,
                edit: true,
            }
        }
        case Keys.LOADTAG_FULFILLED: {
            return {
                ...state,
                edit: action.meta ? action.meta.edit : false,
                tag: { ...action.payload.tag, followers: action.payload.followers }
            }
        }
        case Keys.LOADTAG_REJECTED: {
            return {
                ...state,
                edit: false,
                tag: undefined
            }
        }
        case Keys.SAVETAG_FULFILLED: {
            let tag: tag = action.payload;
            let tags: Array<tag> = [...state.tags];
            var curr = tags?.findIndex(t => t._id === tag._id);
            if (curr > -1)
                tags.splice(curr, 1, tag);
            else
                tags.push(tag);
            return {
                ...state,
                tags: tags,
                edit: false,
            }
        }
        case Keys.SAVETAG_REJECTED: {
            return {
                ...state
            }
        }
        case Keys.UPDATETAG: {
            return {
                ...state,
                tag: { ...action.payload }
            }
        }
        case Keys.CLEARSELECTION: {
            return {
                ...state,
                tag: undefined,
            }
        }
        default:
            return state;
    }
}

